import React, { useState } from 'react';

/**
 * Hover/focus tooltip for icon-only rails. Rendered with `fixed` positioning so
 * scroll containers (overflow-y-auto/hidden) never clip it.
 * @param {{label: string, enabled?: boolean, children: React.ReactNode, className?: string}} props
 */
export default function RailTip({ label, enabled = true, children, className = '' }) {
  const [pos, setPos] = useState(null);
  if (!enabled) return <div className={className}>{children}</div>;
  const show = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setPos({ top: r.top + r.height / 2, left: r.right + 10 });
  };
  return (
    <div className={className} onMouseEnter={show} onMouseLeave={() => setPos(null)} onFocus={show} onBlur={() => setPos(null)}>
      {children}
      {pos && (
        <div
          role="tooltip"
          style={{ top: pos.top, left: pos.left }}
          className="fixed z-50 -translate-y-1/2 whitespace-nowrap rounded-md border border-civix-border bg-civix-panel px-2.5 py-1 text-xs font-medium text-white shadow-lg pointer-events-none"
        >
          {label}
        </div>
      )}
    </div>
  );
}
